import { computeAgeClassFromRules } from './evaluateAgeClassRules';

/**
 * Computes animals.age_class from shared species lifecycle config (API profiles).
 *
 * @param {object} input
 * @param {Record<string, unknown>|null|undefined} [profiles]
 * @param {Record<string, unknown>|null|undefined} [genericAgeClass]
 */
export function computeAgeClass(input, profiles = null, genericAgeClass = null) {
  return computeAgeClassFromRules(input, profiles, genericAgeClass);
}
